/*
 * Stub for react-native-screens for webpack
 * so web builds don't fail
 */
export default {};

export const createNativeStackNavigator = () => {};
export const enableScreens = (enable: boolean) => {};
